import { atom } from 'recoil';

export const toggleSamRequest = atom({
    key: 'aksns-vs-toggleSamRequest',
    default: false,
});

export const toggleQuickConfig = atom({
    key: 'aksns-vs-toggleQuickConfig',
    default: false,
});

export const defaultVmDataDisk = atom({
    key: 'aksns-vs-defaultVmDataDisk',
    default: undefined,
});
export const isDataDiskLoaded = atom({
    key: 'aksns-vs-isDataDiskLoaded',
    default: false,
});
export const defaultOsDiskType = atom({
    key: 'aksns-vs-defaultOsDiskType',
    default: undefined,
});
export const quickConfigDetails = atom({
    key: 'aksns-vs-quickConfigDetails',
    default: undefined,
});
export const toggleSspModels = atom({
    key: 'aksns-vs-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isDiskOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
        isErrorCode: false,
    },
});

export const isValidappSupportMailId = atom({
    key: 'aksns-vs-isValidappSupportMailId',
    default: false,
});

export const isEnvDetailsLoading = atom({
    key: 'aksns-vs-isEnvDetailsLoading',
    default: false,
});

export const isConfigDiskFulfilled = atom({
    key: 'aksns-vs-isConfigDiskFulfilled',
    default: false,
});

export const isMandatoryTagsFullfilled = atom({
    key: 'aksns-vs-isMandatoryTagsFullfilled',
    default: false,
});

export const orderId = atom({
    key: 'aksns-vs-orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 'aksns-vs-sspOrder',
    default: {
        appProfile: null,
        appProfileDetails: null,
        entityDetails: null,
        sector: null,
        environment: null,
        region: null,
        regionDetails: null,
        appSupportMailId: null,
        aksNamespace: null,
        isValidAksNamespace: false,
        nodePool: null,
        nodepoolDetails: null,
        department: 'EDAP',
        departmentDetails: null,
        cluster: null,
        clusterDetails: null,
        project: '',
        hCode: null,
        hCodeDetails: null,
        adGroup: null,
        envDetails: null,
        tags: [],
        estimatedCost: {
            qty: 1,
            totalRecurringCost: {
                item: 'Total Recurring',
                frequency: 'monthly',
                estCost: 0,
                currency: 'USD',
            },
            totalOneTimeCost: {
                item: 'Total One Time',
                frequency: 'One Time',
                estCost: 0,
                currency: 'USD',
            },
        },
        validationStatus: 'clearValidation',
        requestType: '',
        isTouched: false,
    },
});

export const environmentDetails = atom({
    key: 'aksns-vs-environmentDetails',
    default: {
        Project: '-',
        Approval_Manager: '-',
        'ISA Document': '-',
    },
});
export const toggleCurrentServer = atom({
    key: 'aksns-vs-toggleCurrentServer',
    default: false,
});

export const CurrentServerDetails = atom({
    key: 'aksns-vs-CurrentServerDetails',
    default: null,
});
export const validationErrorCode = atom({
    key: 'aksns-vs-validationErrorCode',
    default: null,
});

export const costEstimateState = atom({
    key: 'aksns-vs-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'aksns-vs-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isCostcenterValid = atom({
    key: 'aksns-vs-isCostcenterValid',
    default: false,
});

export const isNamespaceNameValid = atom({
    key: 'aksns-vs-isNamespaceNameValid',
    default: false,
});

export const isAppUrlValid = atom({
    key: 'aksns-vs-isAppUrlValid',
    default: false,
});

export const isAdGroupValid = atom({
    key: 'aksns-vs-isAdGroupValid',
    default: false,
});
